import { Helper } from '@/mixin/helper'

export default [
  {
    path: '/setting/integration/',
    name: 'Integration',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/integration/'),
  },
]
